<script>
import api from '@/command/api'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'

export default {
  name: 'hotel-coupons',
  data() {
    return {
      ...api.command.getState(),
    }
  },
  mounted() {
    api.command.getList.call(this, {
      url: '/roomCouponRule/page',
      current: 1,
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '名称',
          key: 'name',
          type: 'input',
        },
        {},
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'name',
          title: '名称',
          align: 'left',
          customRender: (text, records) => {
            return (
              <div class="product-order-item">
                <div>{text}</div>
              </div>
            )
          },
          sorter: (a, b) => a.name.length - b.name.length,
        },
        {
          dataIndex: 'couponRuleName',
          title: '关联优惠券',
          align: 'left',
          customRender: (text, records) => {
            return (
              <div class="product-order-item">
                <div>{records.couponRuleName}</div>
              </div>
            )
          },
        },
        {
          dataIndex: 'roomCouponRuleType',
          title: '类型',
          align: 'left',
          customRender: (text, records) => {
            return (
              <div class="product-order-item">
                <div>{['金额', '数量'][text]}</div>
              </div>
            )
          },
        },

        {
          dataIndex: 'minAmount',
          title: '订单金额区间(元)',
          align: 'left',
          customRender: (text, records) => {
            if (records.roomCouponRuleType == '1') return '/'
            return (
              <div class="product-order-item">
                <div>
                  {text} - {records.maxAmount}
                </div>
              </div>
            )
          },
        },
        {
          dataIndex: 'productQuantityMin',
          title: '房间数量区间',
          align: 'left',
          customRender: (text, records) => {
            if (records.roomCouponRuleType == '0') return '/'
            return (
              <div class="product-order-item">
                <div>
                  {text} - {records.productQuantityMax}
                </div>
              </div>
            )
          },
        },
        {
          dataIndex: 'updateTime',
          title: '更新时间',
          align: 'left',
          customRender: (text, records) => {
            return text || records.createTime
          },
        },
        {
          dataIndex: 'sort',
          title: '排序',
          align: 'left',
          width: 80,
          customRender: (text) => {
            return text || '0'
          },
        },
        {
          dataIndex: 'a9',
          title: '操作',
          type: 'buttonGroup',
          fixed: 'right',
          typeData: ({ records }) => {
            return [
              {
                name: '编辑',
                onClick: () => this.$router.push(`/commodityManagement/hotelCouponsDetail?id=${records.id}`),
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () =>
                  api.command.del.call(this, {
                    url: `/roomCouponRule/delete?id=${records.id}`,
                  }),
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => this.$router.push('/commodityManagement/hotelCouponsDetail'),
        },
        {
          viewType: 'menu',
          name: '更多操作',
          isBatch: true,
          children: [
            {
              name: '批量删除',
              onClick: (data) => {
                let idList = data.map((e) => e.id)
                return api.command.del.call(this, {
                  url: '/roomCouponRule/deleteBatch',
                  params: { idList },
                })
              },
            },
          ],
        },
      ]
    },
  },
  render() {
    return (
      <div>
        <TemplateHeaderTable
          headerData={this.getHeader()}
          tableColumns={this.getColumns()}
          button={this.getButton()}
          records={this.records}
        />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.product-order-item {
  display: flex;
  align-items: center;
  height: 30px;
  margin-bottom: 15px;
  &:nth-last-of-type(1) {
    margin-bottom: 0;
  }

  img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 15%;
  }
}
</style>
